// Importing required hooks and modules
import React, { useEffect, useRef, useState } from 'react';
import "./CreateProfile.css";
import img from "../../assets/Frame 18140610.png";
import { Link, useNavigate } from 'react-router-dom';

// React Redux 
import { useDispatch } from 'react-redux';
import {setUserId} from "../../redux/userSlice"
import {setCabRequests} from "../../redux/userSlice"
import { baseUrl } from '../../common/baseUrl';
import PageLoader from '../components/PageLoader/PageLoader';

// Loader
// import PageLoader from '../../assets/pageLoader/PageLoader';
import { storeSession } from '../../auth/session';
import axiosInstance from '../../axiosInstance/axiosInstance';
import { clearRedirectPath, getRedirectPath } from '../../common/redirectPath';
import { resolveLandingPath } from '../../common/landing';

export default function CreateProfile({contact,onNextStep,onPrevStep}) {

  // Loading
  // const [loading,setLoading] = useState(false);
 

  const [otp, setOtp] = useState(new Array(6).fill("")); // For OTP
  const [combinedOtp, setCombinedOtp] = useState(""); // State for combined OTP
  // const inputRefs = useRef([]); // For OTP input references
  const [timeLeft, setTimeLeft] = useState(203); // Timer for 3:23 (203 seconds)
  const [canResend, setCanResend] = useState(false); // Flag to enable resend button
  const [otpmsg, setOtpmsg] = useState(""); // State for OTP message

  const [loading,setIsLoading] = useState(false);

  const navigate = useNavigate();
  const otpInputRef = useRef(null);
  


  // Redux Dispatch
  const dispatch = useDispatch(); // Initialize Redux dispatch

  // useEffect(() => {
  //   if (inputRefs.current[0]) {
  //     inputRefs.current[0].focus();
  //   }
  // }, []);

  // Countdown timer effect
 
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearInterval(timerId); // Clear interval on unmount
    } else {
      setCanResend(true); // Enable resend button when the timer ends
    }
  }, [timeLeft]);


  useEffect(() => {
  if (otpInputRef.current) {
    otpInputRef.current.focus();
  }
  }, []);


  // Log the `otpmsg` state whenever it changes
  // useEffect(() => {
  //   // console.log("OTP message: ", otpmsg);
  // }, [otpmsg]);

  // Convert seconds to mm:ss format
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  // Handle resend OTP
  const handleResendOtp = async () => {
    setIsLoading(true);
    // console.log("Resend OTP triggered!");
    setTimeLeft(203); // Reset the timer
    setCanResend(false); // Disable the resend button again
    try {
      const requestData = { contact: contact };
      // console.log("Request: ", requestData.data);

      const response = await axiosInstance.post(
        `/api/v1/user/request-otp`,
        requestData
      );
      // console.log("Response: " + response.data);
      setCombinedOtp(""); // Clear the OTP input
    } catch (error) {
      // console.log("Error in resending OTP");
      console.log(error);
    }
    finally{
      setIsLoading(false);
    }
  };


  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null; // if cookie not found
  }

  // Handle OTP verification submit
  const handleSubmit = async () => {
    setIsLoading(true);
    // console.log("Success:", combinedOtp);
    // Inside the handleSubmit function after successfully receiving the token
    try {
      const inputs = { contact: contact, otp: combinedOtp };
      const response = await axiosInstance.post(
        `/api/v1/user/login`,
        inputs
      );
      // console.log("Response: ", response.data);

      // The session is the token itself; how long it lasts is the `exp` claim the
      // server signed into it, not a cookie we set alongside it.
      const token = response.data.token;
      const user_id = response.data.user_id;
      storeSession(token, user_id);


      const is_contact_verified = true;

      // dispatch(setUserId(response.data.user_id)); 

      

      
      
      // Check Name is There 
      try{
        const response1 = await axiosInstance.get(`/api/v1/users/${response.data.user_id}`);

        // try{
        //   const response2 = await axiosInstance.get(`/api/v1/users/${response.data.user_id}/requests`);

        //   dispatch(setCabRequests(response2.data.data));

        // }catch(error){
        //   console.log(error);
        // }

        if(response1.data.name!==""){
          localStorage.setItem("userName",response1.data.name);

          try{
            let userId = localStorage.getItem("user_id")

            // Came in from a link we sent them, so send them back to it
            const redirectPath = getRedirectPath();
            if(redirectPath){
              clearRedirectPath();
              navigate(redirectPath);
              return;
            }

            const hotelId = getCookie("hotelId");
            const tableId = getCookie("tableId");

            if(hotelId && tableId){
              navigate(`/hotels/${hotelId}/table/${tableId}`);
              return;
            }

            navigate(await resolveLandingPath(userId));

          }catch(error){
            console.log(error);
          }
          // navigate("/bookings");
        }
        else{
          onNextStep(response.data.user_id,is_contact_verified);
        }

      }catch(error){
        console.log("Error in CreateProfile :",error);
      }
      
      // Passing and Redirecting Over Here user_id
      // navigate(`/users/${response.data.user_id}`, {
      //   state: { contact: contact, token: response.data.token,user_id : response.user_id, is_contact_verified:is_contact_verified }
      // });
    } catch (error) {
      console.log(error);
      
      if (error.response && error.response.data) {
        setOtpmsg(error.response.data.message || "Invalid OTP. Please try again.");
      } else {
        setOtpmsg("An error occurred. Please try again.");
      }
    }finally{
      setIsLoading(false);
    }
  };

  // Handle change for OTP input
  // const handleChange = (index, e) => {
  //   const value = e.target.value;
  //   if (isNaN(value)) return;

  //   const newOtp = [...otp];

  //   // Allow only one input value
  //   newOtp[index] = value.substring(value.length - 1);
  //   setOtp(newOtp);

  //   // Combine OTP
  //   const newCombinedOtp = newOtp.join("");
  //   setCombinedOtp(newCombinedOtp);

  //   // Move to the next input field if the current one is filled
  //   if (value && index < 5 && inputRefs.current[index + 1]) {
  //     inputRefs.current[index + 1].focus();
  //   }
  // };

  // Handle click on OTP input field
  // const handleClick = (index) => {
  //   inputRefs.current[index].setSelectionRange(1, 1);
  // };

  // Handle keydown for OTP input field
  // const handleKeyDown = (index, e) => {
  //   if (e.key === "Backspace" && !otp[index] && index > 0 && inputRefs.current[index - 1]) {
  //     // Move focus to the previous input field on backspace
  //     inputRefs.current[index - 1].focus();
  //   }
  // };


  // Loading
  // if (loading) {
  //   return  <div style={{
  //     position: 'fixed',
  //     top: 0,
  //     left: 0,
  //     right: 0,
  //     bottom: 0,
  //     backgroundColor: 'rgba(255, 255, 255, 0.8)',
  //     display: 'flex',
  //     justifyContent: 'center',
  //     alignItems: 'center',
  //     zIndex: 9999, // Make sure the loader is on top
  //     opacity :0.9
  //   }}>
  //     <PageLoader/>
  //   </div>
  // }

  // const handlePaste = (e) => {
  //   try{
  //     e.preventDefault();
  //     const paste = e.clipboardData.getData('text').trim();
  //     if (!/^\d{6}$/.test(paste)) return; // Optional: Ensure it's a 6-digit number
  
  //     const newOtp = paste.split("");
  //     setOtp(newOtp);
  //     setCombinedOtp(paste);
  
  //     // Update each input and focus
  //     newOtp.forEach((digit, i) => {
  //       if (inputRefs.current[i]) {
  //         inputRefs.current[i].value = digit;
  //       }
  //     });
  
  //     if (inputRefs.current[5]) {
  //       inputRefs.current[5].focus();
  //     }
  //   }catch(error){
  //     console.log(error)
  //   }
  // };


  


  return (
    <>
      {
        loading && <PageLoader/>
      }
      <div className="create-profile-main">
        <div className="create1">
          <div className="create1-img">
            <img src={img} alt="error" />
          </div>
          <div className="create1-account">
            <div className="create1-header">
              <h3>Create Profile</h3>
            </div>
            <div className="create1-desc">
              <p>Verification Code Sent to : +{contact}</p>
              <Link to="/" onClick={onPrevStep}>Change Number</Link>
            </div>

            {/* OTP field */}
            <div className="create1-inp">
              {/* OTP Code */}
              {/* <div className="create1-inputs">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode='numeric'
                    value={value}
                    onChange={(e) => handleChange(index, e)}
                    onClick={() => handleClick(index)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={(e) => handlePaste(e)} // ← Add this line
                    className="otpInput"
                    ref={(input) => {
                      inputRefs.current[index] = input;
                    }}
                  />
                ))}
              </div> */}
               <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="Enter Your OTP"
                value={combinedOtp}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, ""); // allow only digits
                  setCombinedOtp(val);
                }}
                className="otpInput"
                name = "otp"
                ref={otpInputRef}
              />

            </div>

            {/* Display the OTP message */}
            {otpmsg && <div  style={{color : "#FF7378"}}>{otpmsg}</div>}

            <div className="create1-desc">
              <p>Didn't Receive the Code?</p>
              {canResend ? (
                <button onClick={handleResendOtp} className="resend-btn">Resend</button>
              ) : (
                <span>Resend OTP in {formatTime(timeLeft)}</span>
              )}
            </div>
          </div>
        </div>

        <div className="create2-btn">
          <button onClick={handleSubmit} disabled={combinedOtp.length !== 6}>
            Verify
          </button>
        </div>
      </div>
    </>
  );
}
